/* Esto abre el menú */
const getMenu = document.querySelector(".responsive-header-label");


getMenu?.addEventListener("click", () => {
  const menu = document.querySelector(".menu");
  menu.classList.add("open");
});

/* Esto cierra el menú */
const closeButton = document.querySelector(".responsive-close-button");

closeButton?.addEventListener("click", () => {
  const menu = document.querySelector(".menu");
  menu.classList.remove("open");
});

const arrowButton = document.querySelectorAll(".arrow-submenu");
// const responsiveMenu = document.querySelector("#responsive-menu");
// const littleSubMenu = document.querySelector("#little-submenu");

// console.log({ responsiveMenu, arrowButton, littleSubMenu });

arrowButton?.forEach((button) => {
  button.addEventListener("click", (e) => {
    if (!e.currentTarget.dataset) return;

    console.log("CLICK", document.getElementById(e.currentTarget.dataset.id));
    document
      .getElementById(e.currentTarget.dataset.id)
      .classList.toggle("active");
  });
});

document.querySelectorAll(".arrow-return").forEach((arrow) => {
  arrow.addEventListener("click", (e) => {
    if (!e.currentTarget.dataset) return;

    console.log("CLICK", document.getElementById(e.currentTarget.dataset.id));
    document
      .getElementById(e.currentTarget.dataset.id)
      .classList.toggle("active");
  });
});

const arrowSubmenu = document.querySelector("div.header__menu-item");
const subMenuDesk = document.querySelector(".custom-submenu");

/* arrowSubmenu.addEventListener('click', () => {
    if (subMenuDesk.style.display == '' || subMenuDesk.style.display == 'none')
        subMenuDesk.style.display = 'grid'
    else
        subMenuDesk.style.display = 'none'
}) */

$("div.header__menu-item").mouseenter(function () {
  if (subMenuDesk.style.display == "" || subMenuDesk.style.display == "none")
    subMenuDesk.style.display = "grid";
});

$(".custom-submenu").mouseleave(function () {
  subMenuDesk.style.display = "none";
});

/*
  Fallback de envío para el buscador móvil.
  Algunos teclados/navegadores integrados de Android no disparan de forma fiable
  el envío implícito del formulario al pulsar la tecla de acción ("Ir/Buscar"),
  lo que dejaba al usuario en la misma página (scroll al footer) en lugar de
  navegar a /search. Aquí forzamos el envío nosotros al pulsar Enter.
*/
const mobileSearchForm = document.querySelector(".menu-header-search-mobile");
const mobileSearchInput = mobileSearchForm?.querySelector('input[name="q"]');

mobileSearchInput?.addEventListener("keydown", (keyboardEvent) => {
  if (keyboardEvent.key !== "Enter") return;
  if (!mobileSearchInput.value.trim()) return;

  keyboardEvent.preventDefault();
  if (typeof mobileSearchForm.requestSubmit === "function") {
    mobileSearchForm.requestSubmit();
  } else {
    mobileSearchForm.submit();
  }
});
